import React from "react";

const PopCast = () => {
  return (
    <div className="option__music__list" style={{ marginTop: "20px" }}>
      <a href="#" className="item__music__option active__option__library">
        tập mới
      </a>
      <a href="#" className="item__music__option">
        tệp đã lưu
      </a>
      <a href="#" className="item__music__option">
        chương trình
      </a>
    </div>
  );
};

export default PopCast;
